import axios from "axios";
import React, { useState } from "react";
import { baseUrl } from "../config";
import styled from "styled-components";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { hasContributorAccess } from "../authRoles";
import {Button} from "./styles";

const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState(null);
  const { setIsLoggedIn, setPseudo, setRoles } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(baseUrl + "/login", formData);
      setMessage("Connexion réussie, bienvenue: " + formData.email);
      setIsLoggedIn(true);
      setPseudo(response.data.pseudo);
      const roles = response.data?.user?.roles;
      setRoles(Array.isArray(roles) ? roles : []);
      if (Array.isArray(roles) && !hasContributorAccess(roles)) {
        navigate("/me/profile", { replace: true });
      } else {
        navigate("/home", { replace: true });
      }
    } catch (error) {
      console.error("Login error:", error);
      if (error.response) {
        if (error.response.status === 400) {
          setError("Tous les champs sont requis.");
        } else {
          setError("Erreur, vérifier votre pseudo/email ou mot de passe");
        }
      } else {
        // Autres erreurs (réseau, etc.)
        setError("Erreur réseau. Veuillez réessayer plus tard.");
      }
    }
  };

  return (
    <FormContainer>
      <h2>Se connecter</h2>
      <form onSubmit={handleSubmit}>
        <label>
          Email:
          <input
            type="string"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Mot de passe:
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </label>
        <Button type="submit">Se connecter</Button>
      </form>
      {message && <p>{message}</p>}
      {error && <ErrorText>{error}</ErrorText>}
      <p>
        <Link to="/forgot-password">Mot de passe oublié ?</Link>
      </p>
    </FormContainer>
  );
};

const FormContainer = styled.div`
  width: min(100%, 560px);
  margin: 0 auto;
  margin-top: var(--space-8);
  padding: 20px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface-2);

  h2 {
    margin-bottom: 20px;
  }

  label {
    display: block;
    margin-bottom: 10px;

    input {
      width: 100%;
      padding: 8px;
      margin-top: 5px;
      border: 1px solid var(--border);
      border-radius: var(--radius-sm);
      background: transparent;
      color: var(--text);
    }
  }

  button {
    margin-top: 20px;
  }

  p {
    margin-top: 10px;
    color: var(--text-muted);
  }
`;

const ErrorText = styled.p`
  margin-top: 10px;
  color: red;
  overflow-wrap: anywhere;
`;

export default Login;
